export const BACKGROUND_COLOR = {
  default: 'default',
  brand: 'brand',
  brandAlt: 'brand-alt',
} as const;
export type BackgroundColor = (typeof BACKGROUND_COLOR)[keyof typeof BACKGROUND_COLOR];
